module.exports = __webpack_public_path__ + "img/stella_ceo.c9580357.png";